import React, { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const from = loc.state?.from?.pathname || "/admin";

  if (admin) return <Navigate to={from} replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav(from, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Invalid email or password";
      toast.error(msg);
    } finally { setSubmitting(false); }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen flex items-center justify-center px-6 py-32">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="flex items-center gap-2 mb-8">
          <Lock size={16} className="text-[var(--primary)]" />
          <span className="overline">Admin Access</span>
        </div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter">
          Sign in to
          <br />
          <span className="text-[var(--primary)]">manage inventory.</span>
        </h1>

        <form onSubmit={onSubmit} className="glass rounded-2xl p-8 mt-10 space-y-5" data-testid="admin-login-form">
          <div>
            <label>Email</label>
            <input required type="email" autoComplete="email" data-testid="admin-email"
              value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label>Password</label>
            <input required type="password" autoComplete="current-password" data-testid="admin-password"
              value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button disabled={submitting} type="submit" className="btn-primary w-full justify-center" data-testid="admin-submit">
            {submitting ? "Signing in..." : (<><LogIn size={16} /> Sign In</>)}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
